export const env = {
  API_URL: process.env.REACT_APP_API_URL || 'http://localhost:3001',
} as const;

export type Environment = typeof env;